import { render, staticRenderFns } from "./PagesTaskGroupsIndex.vue?vue&type=template&id=5e60d3e5&"
import script from "./PagesTaskGroupsIndex.vue?vue&type=script&lang=js&"
export * from "./PagesTaskGroupsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports